// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"bce34804","280":"9a30bee6","381":"9a30bee6","470":"bf7c6f76","709":"9a30bee6"}[chunkId] + ".chunk.css";
};